export default __webpack_public_path__ + "static/media/deposit.afbc7ed9.svg";